"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.userAppsReset = exports.deleteUserAppError = exports.deleteUserAppSuccess = exports.deleteUserApp = exports.pullUserAppsError = exports.pullUserAppsSuccess = exports.pullUserApps = exports.loadUserAppsError = exports.loadUserAppsSuccess = exports.loadUserApps = void 0;

var loadUserApps = function loadUserApps(userId) {
  return {
    type: 'OLY_LOAD_USER_APPS',
    payload: {
      userId: userId
    }
  };
};

exports.loadUserApps = loadUserApps;

var loadUserAppsSuccess = function loadUserAppsSuccess(loadUserApps) {
  return {
    type: 'OLY_LOAD_USER_APPS_SUCCESS',
    payload: {
      loadUserApps: loadUserApps
    }
  };
};

exports.loadUserAppsSuccess = loadUserAppsSuccess;

var loadUserAppsError = function loadUserAppsError(error) {
  return {
    type: 'OLY_LOAD_USER_APPS_ERROR',
    payload: {
      error: error
    }
  };
};

exports.loadUserAppsError = loadUserAppsError;

var pullUserApps = function pullUserApps(payload) {
  return {
    type: 'OLY_PULL_USER_APPS',
    payload: payload
  };
};

exports.pullUserApps = pullUserApps;

var pullUserAppsSuccess = function pullUserAppsSuccess() {
  return {
    type: 'OLY_PULL_USER_APPS_SUCCESS'
  };
};

exports.pullUserAppsSuccess = pullUserAppsSuccess;

var pullUserAppsError = function pullUserAppsError(error) {
  return {
    type: 'OLY_PULL_USER_APPS_ERROR',
    payload: {
      error: error
    }
  };
};

exports.pullUserAppsError = pullUserAppsError;

var deleteUserApp = function deleteUserApp(payload) {
  return {
    type: 'OLY_DELETE_USER_APP',
    payload: payload
  };
};

exports.deleteUserApp = deleteUserApp;

var deleteUserAppSuccess = function deleteUserAppSuccess(deletedAppName) {
  return {
    type: 'OLY_DELETE_USER_APP_SUCCESS',
    payload: {
      deletedAppName: deletedAppName
    }
  };
};

exports.deleteUserAppSuccess = deleteUserAppSuccess;

var deleteUserAppError = function deleteUserAppError(error) {
  return {
    type: 'OLY_DELETE_USER_APP_ERROR',
    payload: {
      error: error
    }
  };
};

exports.deleteUserAppError = deleteUserAppError;

var userAppsReset = function userAppsReset() {
  return {
    type: 'OLY_USER_APP_RESET'
  };
};

exports.userAppsReset = userAppsReset;
var _default = {
  loadUserApps: loadUserApps,
  loadUserAppsSuccess: loadUserAppsSuccess,
  loadUserAppsError: loadUserAppsError,
  pullUserApps: pullUserApps,
  pullUserAppsSuccess: pullUserAppsSuccess,
  pullUserAppsError: pullUserAppsError,
  deleteUserApp: deleteUserApp,
  deleteUserAppSuccess: deleteUserAppSuccess,
  deleteUserAppError: deleteUserAppError,
  userAppsReset: userAppsReset
};
exports["default"] = _default;
//# sourceMappingURL=actions.js.map